import axios from "axios";

const clienteAxios = axios.create({
  //  baseURL: "http://localhost:4000/",
  baseURL: "https://backtableromonteolivo.neitor.com",
});

export default clienteAxios;
